import { Select } from 'antd';

import { useTranslation } from '@/i18n/client';

import styles from './index.less';

interface IProps {
  languageCode: string;
  languageList: LanguageItem[];
  setSelectedLanguage: (value: string) => void;
  tips?: string;
}

export interface LanguageItem {
  englishName: string;
  languageCode: string;
  nativeName: string;
}

const AppLanguage: React.FC<IProps> = (prop) => {
  const { t } = useTranslation();
  const {
    languageList,
    setSelectedLanguage,
    languageCode,
    tips = t('leftTabs.appLanguageModal.tip')
  } = prop;

  return (
    <div className="w-full">
      <Select
        className="w-full"
        onChange={(value) => {
          setSelectedLanguage(value);
        }}
        options={languageList.map((item) => {
          return {
            label: item.nativeName,
            value: item.languageCode
          };
        })}
        value={languageCode}
      />
      {tips ? <div className={styles.tips}>{tips}</div> : null}
    </div>
  );
};

export default AppLanguage;
